import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { memo, useRef } from 'react';
import useViewbox from '../../useViewbox.js';
const SvgLogoSmall = memo((componentProps) => {
    const ref = useRef(null);
    useViewbox(ref);
    const props = {
        ...componentProps,
        ref,
        className: 'spriteIcon'
    };
    return (_jsx("svg", { role: "presentation", viewBox: "0 0 48 54", ...props, children: _jsxs("g", { fill: "none", fillRule: "evenodd", children: [_jsx("path", { fill: "#e5832d", d: "m41.812 53.945c-2.674 0-4.551-.463-5.631-1.388-1.08-.927-2.006-2.701-2.777-5.324l-1.466-5.092h-17.049l-3.317 11.186c-1.235.309-2.958.463-5.169.463-2.469 0-4.474-.283-6.017-.848l-.386-.618 16.352-47.253c.605-.926 1.412-1.214 2.324-1.214 1.508 0 3.307.788 4.974.788 2.234 0 3.824-.272 5.227-.272.502 0 .98.035 1.455.129l17.575 47.976c-1.801.977-3.832 1.467-6.095 1.467m-18.352-32.999-5.716 12.691h11.494z" }), _jsx("path", { fill: "#f2b12a", d: "m30.948 7.488a7.488 7.488 0 0 0 -14.976 0c0 4.135 7.488 13.458 7.488 13.458s7.488-9.323 7.488-13.458" })] }) }));
});
export default SvgLogoSmall;
//# sourceMappingURL=LogoSmall.js.map